import { Modal, SubmitButton } from "@xola/ui-kit";
import React, { ReactNode } from "react";
import { SecondaryButton } from "./SecondaryButton";

interface PromptModalProps {
    title?: string;
    titleDataTestId?: string;
    children: ReactNode;
    color?: string;
    isLoading?: boolean;
    readOnly?: boolean;
    dialogText?: {
        secondary?: string;
        submit: string;
    };
    dialogDataTestIds?: {
        secondaryTestId?: string;
        submitTestId: string;
    };
    onConfirm: (e: any) => void;
    onClose: (e: any) => void;
    isOpen: boolean;
    isPrimaryButtonDisabled?: boolean;
}

export const PromptModal = ({
    title = "Warning",
    titleDataTestId,
    isOpen,
    color = "danger",
    isLoading = false,
    dialogText = { secondary: "Cancel", submit: "Confirm" },
    dialogDataTestIds = { secondaryTestId: "secondary-button", submitTestId: "submit-button" },
    readOnly = false,
    children,
    isPrimaryButtonDisabled = false,
    onClose,
    onConfirm,
}: PromptModalProps) => {
    const { secondary, submit } = dialogText;
    const { secondaryTestId, submitTestId } = dialogDataTestIds;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Modal.Header>{titleDataTestId ? <span data-testid={titleDataTestId}>{title}</span> : title}</Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            {!readOnly && (
                <Modal.Footer>
                    <fieldset className="flex justify-end space-x-4">
                        {!!secondary && (
                            <SecondaryButton disabled={isLoading} data-testid={secondaryTestId} onClick={onClose}>
                                {secondary}
                            </SecondaryButton>
                        )}

                        <SubmitButton
                            type="button"
                            disabled={isPrimaryButtonDisabled}
                            color={color}
                            isLoading={isLoading}
                            data-testid={submitTestId}
                            onClick={onConfirm}
                        >
                            {submit}
                        </SubmitButton>
                    </fieldset>
                </Modal.Footer>
            )}
        </Modal>
    );
};
